// src/pages/PrivacyPage.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { 
  Box, 
  Container, 
  Typography, 
  Toolbar,
  Paper
} from '@mui/material';
import PublicHeader from '../components/PublicHeader';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const PrivacyPage = () => {
  const { t } = useTranslation('legal');

  const privacyBreadcrumb = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "首頁", "item": "https://rebaz.ai" },
      { "@type": "ListItem", "position": 2, "name": t('privacy.title'), "item": "https://rebaz.ai/privacy" }
    ]
  };

  return (
    <>
      <SEO
        title={t('privacy.title')}
        description={t('privacy.description')}
        canonicalUrl="https://rebaz.ai/privacy"
        breadcrumb={privacyBreadcrumb}
      />
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        minHeight: '100vh'
      }}>
        {/* Header */}
        <PublicHeader />
        <Toolbar />

        {/* Main Content */}
        <Box component="main" sx={{ flexGrow: 1, py: 6, backgroundColor: '#f5f5f5' }}>
          <Container maxWidth="md">
            <Paper elevation={2} sx={{ p: { xs: 3, md: 5 }, borderRadius: 2 }}>
              <Typography variant="h3" component="h1" fontWeight="bold" gutterBottom>
                {t('privacy.title')}
              </Typography>
              
              <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
                {t('privacy.lastUpdated')}
              </Typography>

              {/* Section 1: Introduction */}
              <Typography variant="h5" component="h2" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
                {t('privacy.sections.introduction.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('privacy.sections.introduction.content')}
              </Typography>

              {/* Section 2: Information We Collect */}
              <Typography variant="h5" component="h2" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
                {t('privacy.sections.dataCollection.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('privacy.sections.dataCollection.content')}
              </Typography>

              {/* Section 3: How We Use Information */}
              <Typography variant="h5" component="h2" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
                {t('privacy.sections.dataUsage.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('privacy.sections.dataUsage.content')}
              </Typography>

              {/* Section 4: Data Sharing */}
              <Typography variant="h5" component="h2" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
                {t('privacy.sections.dataSharing.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('privacy.sections.dataSharing.content')}
              </Typography>

              {/* Section 5: Data Security */}
              <Typography variant="h5" component="h2" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
                {t('privacy.sections.dataSecurity.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('privacy.sections.dataSecurity.content')}
              </Typography>

              {/* Section 6: Your Rights */}
              <Typography variant="h5" component="h2" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
                {t('privacy.sections.userRights.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('privacy.sections.userRights.content')}
              </Typography>

              {/* Section 7: Cookies */}
              <Typography variant="h5" component="h2" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
                {t('privacy.sections.cookies.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('privacy.sections.cookies.content')}
              </Typography>

              {/* Section 8: Contact */}
              <Typography variant="h5" component="h2" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
                {t('privacy.sections.contact.title')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('privacy.sections.contact.content')}
              </Typography>
              <Typography variant="body1">
                Email: service@rebaz.ai
              </Typography>
            </Paper>
          </Container>
        </Box>

        {/* Footer */}
        <Footer />
      </Box>
    </>
  );
};

export default PrivacyPage;